import { useState } from "react"

import { faIcon } from "@utils/faIcon"

import { IconButton } from "@atoms"

import Menu from "@organisms/Menu/Menu"

import styles from "./NavTopBarContextMenu.module.scss"
import { NavTopBarContextMenuProps } from "./NavTopBarContextMenu.types"

export default function NavTopBarContextMenu(props: NavTopBarContextMenuProps) {
    const { items, title, avatar } = props

    const [isOpen, setIsOpen] = useState<boolean>(false)

    return (
        <div className={styles.base}>
            <Menu
                title={title}
                headerLeft={avatar}
                items={items}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                popoverSide="bottom"
                popoverAlign="start"
                trigger={
                    <IconButton
                        size="lg"
                        variant="ghost"
                        icon={faIcon({ name: "ellipsis", style: "regular" })}
                        onClick={() => {}}
                        aria-label="More actions"
                        noDebounce={true}
                        isPressed={isOpen}
                    />
                }
            />
        </div>
    )
}
